import { PageHero } from "@/components/site/PageHero";
import { motion } from "framer-motion";
import { Reveal, SectionLabel } from "@/components/site/primitives";
import { FOUNDATION_ACTIVITIES, LOGOS } from "@/data/content";

export default function Foundation() {
  return (
    <div data-testid="foundation-page">
      <PageHero
        label="Raritan Karmanya Foundation"
        titleLines={["Empowering", "communities", "through inclusion"]}
        intro="The social impact and community development arm of the Raritan ecosystem — because sustainable sanitation succeeds only when communities participate."
        testId="foundation-hero"
      />

      {/* Editorial statement with image */}
      <section className="px-5 md:px-10 py-24 md:py-32 border-b border-raritan-border">
        <div className="max-w-[1400px] mx-auto grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-6">
            <Reveal>
              <p className="font-serif italic text-3xl md:text-5xl leading-[1.15] text-raritan-green">
                &ldquo;Sustainable sanitation systems can only succeed when communities actively participate in behavioral transformation and environmental responsibility.&rdquo;
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <p className="mt-8 font-body text-lg text-raritan-muted leading-relaxed max-w-xl">
                The foundation works to create awareness, strengthen community participation, and support vulnerable groups associated with sanitation and urban livelihoods.
              </p>
            </Reveal>
          </div>
          <div className="lg:col-span-6">
            <Reveal delay={0.1}>
              <div className="relative flex items-center justify-center p-8 md:p-12 bg-raritan-green-soft border border-raritan-border">
                <motion.img
                  src={LOGOS.foundation}
                  alt="Raritan Karmanya Foundation emblem"
                  className="w-full max-w-[380px] h-auto object-contain drop-shadow-sm"
                  initial={{ opacity: 0, scale: 0.9, rotate: -6 }}
                  whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
                />
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      {/* Activities */}
      <section className="px-5 md:px-10 py-24 md:py-32">
        <div className="max-w-[1400px] mx-auto">
          <SectionLabel className="mb-6">Key initiatives</SectionLabel>
          <h2 className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-raritan-ink mb-16">How we create impact</h2>
          <div className="grid md:grid-cols-3 gap-px bg-raritan-border border border-raritan-border">
            {FOUNDATION_ACTIVITIES.map((a, i) => (
              <Reveal key={a.title} delay={i * 0.1}>
                <div className="bg-raritan-surface p-8 md:p-10 h-full hover:bg-raritan-green-soft transition-colors duration-500">
                  <span className="font-mono text-sm text-raritan-red">0{i + 1}</span>
                  <h3 className="mt-5 font-heading font-bold text-2xl text-raritan-ink">{a.title}</h3>
                  <p className="mt-4 font-body text-raritan-muted leading-relaxed">{a.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
